import { SR_API_ACTION_UTILITY_ACTIVATION_GET } from 'api/utilityActionTypes';

export default async function getByAddressId(
  { state, utilityApiClient },
  { addressId, forceRefresh = false },
) {
  const statePath = ['utilityActivations', 'byAddressId', addressId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET,
    state: state,
    queryId: addressId,
    payload: {
      addressId,
    },
    onSuccess(utilityActivation) {
      state.set(statePath, utilityActivation);
    },
  });
}
